import { render } from "./HeadlineSub.vue?vue&type=template&id=5f9ee2c0"
import script from "./HeadlineSub.vue?vue&type=script&lang=js"
export * from "./HeadlineSub.vue?vue&type=script&lang=js"

import exportComponent from "C:\\projects\\Vue_Webinterface\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__